import { Component, inject } from '@angular/core';
import { CustomModal } from '../../shared/services/ziro-modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../shared/services/toast.service';
import { ButtonSizes, ButtonStyles, ZiroButtonComponent } from '../../button/button.component';
import { ZiroIcons } from '../../shared/models/ziro-icons.enum';
import { ToastTypes } from '../../shared/services/abstract/toast.service.abstract';
import { FileDownloadService } from '../../shared/services/file-download.service';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../shared/pipes/pipes.module';

export interface MigrationsDownloadFile {
  title: string;
  description: string;
  fileType: string;
  label: string;
  uri: string;
  isPending?: boolean;
}

export interface MigrationsDownloadFilesModalViewProperties {
  reportTitle: string;
  buttons: {
    [key: string]: MigrationsDownloadFile;
  };
}

@Component({
  selector: 'ziro-migrations-download-files-modal',
  imports: [ZiroButtonComponent, TranslateModule, PipesModule],
  templateUrl: './migrations-download-files-modal.component.html',
})
export class MigrationsDownloadFilesModalComponent implements CustomModal<MigrationsDownloadFilesModalViewProperties> {
  private _activeModal = inject(NgbActiveModal);
  private _toastService = inject(ToastService);
  private _fileDownloadService = inject(FileDownloadService);

  modalProperties: MigrationsDownloadFilesModalViewProperties;
  buttonStyles = ButtonStyles;
  buttonSizes = ButtonSizes;
  ziroIcons = ZiroIcons;

  downloadFile(key: string, fileDownload: MigrationsDownloadFile): void {
    this.modalProperties.buttons[key].isPending = true;
    this._fileDownloadService.downloadFile(fileDownload.uri).subscribe(() => {
      this.modalProperties.buttons[key].isPending = false;
      this._toastService.push(
        ToastTypes.SUCCESS,
        ZiroIcons.DOWNLOAD,
        'tkey;migrations.cisco.reports_list.table.file_download.toast.title',
        'tkey;migrations.cisco.reports_list.table.file_download.toast.message',
        { fileType: fileDownload.fileType },
      );
    });
  }

  onClose(): void {
    this._activeModal.close();
  }

  getButtonKeys(): string[] {
    return this.modalProperties ? Object.keys(this.modalProperties.buttons) : null;
  }

  protected readonly icons = ZiroIcons;
  protected readonly buttonStyle = ButtonStyles;
}
